import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

turbolinksLoadedObservable.subscribe(() => {
  $('.switch-item').click((e) => {
    $('.center-top-menu').toggleClass('hidden')
    $(e.currentTarget).toggleClass('second')
  })
})
